import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { canOpenPath, firstAllowedPath, limitedAccess } from '@/lib/access';

/**
 * Уводит менеджера и «свой набор» из раздела, который владелец ему не открыл.
 *
 * Закладка или ссылка из старого сообщения могла остаться, а экран, где каждый запрос
 * отбивается 403, хуже, чем возврат туда, где человеку всё доступно. Права проверяет бэк;
 * это только удобство, не защита.
 */
export function AccessGuard({ pathname }: { pathname: string }) {
  const navigate = useNavigate();
  const { data: me } = useQuery({ queryKey: ['partner'], queryFn: () => api.me() });
  const access = limitedAccess(me);

  useEffect(() => {
    if (access === null || canOpenPath(access, pathname)) return;
    void navigate({ to: firstAllowedPath(access) as '/more', replace: true });
  }, [access, pathname, navigate]);

  return null;
}
